<template>
    <div class="position-relative" style="width: 30px">
      <el-image style="width: 28px; height: 28px; border-radius: 2px;" fit="cover"
                :src="item.url?item.url:'https://chat.zalo.me/assets/icon-file-empty.6796cfae2f36f6d44242f7af6104f2bb.svg'" />
      <el-tooltip class="item" effect="dark" :content="name" placement="bottom-start">
        <div style="" class="w-100 font-size-11 fw-semibold text-break rounded-1  text-center w-100 text-2-line-new ">
          {{ name }}
        </div>
      </el-tooltip>
    </div>
  </template>
  
  <script>
  import Config from "../../lib/Config";
  
  export default {
    name: "File",
    props: {
      item: {
        type: Object
      }
    },
    data() {
      return {
        name: "",
        contentType: "",
        source: ""
      };
    },
    methods: {
      getUrlImage(image) {
        let HOST = "";
        if (Config.DEV) {
          HOST = Config.HOST;
        } else {
          HOST = "https://zalo.salework.net";
        }
        return HOST + "/api/image/" + image;
      },
      getNameFile() {
        return this.$http.get("/api/image/" + this.item.id).then(resp => {
          if (!resp.data) {
            this.source = this.getUrlImage(this.id);
            return;
          }
          let data = resp.data;
          this.name = data.fileName;
        });
  
      }
    },
    created() {
      // this.getNameFile();
    }
  };
  </script>
  
  <style scoped>
  
  </style>